import React, {useState} from 'react';
import './App.css';
import Navbar from "./Components/Navbar/Navbar";
import Hero from "./Components/Pages/Home";
import Rules from "./Components/Pages/Rules";
import Form from "./Components/Pages/Form";
import Jury from "./Components/Pages/Jury";
import Footer from "./Components/Footer/Footer";
import {Navigation} from "./Types/navigationType";
import styled from "styled-components";
import CookieConsent from "react-cookie-consent";
import HeroEnglish from "./Components/Pages/HomeEnglish";
import RulesEnglish from "./Components/Pages/RulesEnglish";
import FormEnglish from "./Components/Pages/FormEnglish";
import JuryEnglish from "./Components/Pages/JuryEnglish";
import BannerExtend from "./Components/Pages/ExtendedBanner";
import Voting from "./Components/Pages/Voting";

function App() {

    const [page, setPage] = useState(Navigation.HOME);
    const [isEng, setEng] = useState(false);
    const [register, setRegister] = useState(true);

    // @ts-ignore
    return (
        <Wrapper>
            <Navbar setPage={setPage} setEng={setEng} isEng={isEng} register={register}/>

            {isEng ?
                (<Content>
                    {/*<BannerExtend/>*/}
                    {page === Navigation.HOME && <HeroEnglish/>}
                    {page === Navigation.RULES && <RulesEnglish/>}
                    {page === Navigation.FORM && <FormEnglish/>}
                    {page === Navigation.JURY && <JuryEnglish/>}
                {/*//@ts-ignore*/}
                    {page === Navigation.VOTING && <Voting/>}
                    <Footer/>
                </Content>)

                : (<Content>
                    {/*<BannerExtend/>*/}
                    {page === Navigation.HOME && <Hero/>}
                    {page === Navigation.RULES && <Rules/>}
                    {page === Navigation.FORM && <Form/>}
                    {page === Navigation.JURY && <Jury/>}
                    {/*//@ts-ignore*/}
                    {page === Navigation.VOTING && <Voting/>}
                    <Footer/>
                </Content>)
            }

            <CookieConsent buttonText="Akceptuję"
                           enableDeclineButton
                           declineButtonText="Nie dziękuję"
                           onDecline={() => {
                               setRegister(false)
                           }
                           }>
                Ta strona używa ciasteczek. Zapoznaj się z regulaminem oraz polityką prywatności.</CookieConsent>
        </Wrapper>
    )
        ;
}

export default App;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`


const Content = styled.div`
  position: absolute;
  top: 55%;

  @media (max-width: 1600px) {
    top: 50%;
  }

  @media (max-width: 1300px) {
    top: 45%;
  }

  @media (max-width: 1100px) {
    top: 40%;
  }

  @media (max-width: 900px) {
    top: 35%;
  }
  @media (max-width: 700px) {
    top: 30%;
  }

  @media (max-width: 600px) {
    top: 25%;
  }

  @media (max-width: 500px) {
    top: 20%;
  }

  @media (max-width: 400px) {
    top: 15%;
  }
`


